
        import _47rails_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47icons_46js from "/rails/node_modules/@nuxt/ui/dist/runtime/vue/plugins/icons.js"
import _47rails_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47head_46js from "/rails/node_modules/@nuxt/ui/dist/runtime/vue/plugins/head.js"
import _47rails_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47router_46js from "/rails/node_modules/@nuxt/ui/dist/runtime/vue/plugins/router.js"
import _47rails_47node_modules_47_64nuxt_47ui_47dist_47runtime_47plugins_47colors_46js from "/rails/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js"
import _47rails_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47color_45mode_46js from "/rails/node_modules/@nuxt/ui/dist/runtime/vue/plugins/color-mode.js"
        

export default {
  install (app, pluginOptions = {}) {
    app.use(_47rails_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47icons_46js, pluginOptions)
    app.use(_47rails_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47head_46js, pluginOptions)
    app.use(_47rails_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47router_46js, pluginOptions)
    app.use(_47rails_47node_modules_47_64nuxt_47ui_47dist_47runtime_47plugins_47colors_46js, pluginOptions)
    app.use(_47rails_47node_modules_47_64nuxt_47ui_47dist_47runtime_47vue_47plugins_47color_45mode_46js, pluginOptions)

  }
}
        